import { REMOVE_TERMINALS_FROM_GROUP } from "./../graphql/mutations/removeTerminalsFromGroup"
import { useMutation } from "@apollo/client"
import { GET_SUGGESTED_GROUPS_TERMINAL } from "../graphql/queries/getSuggestedGroupsTerminal"
import { GET_MY_ORG_GROUPS } from "../graphql/queries/getMyOrgGroups"
import { GET_ALL_GROUPS } from "../graphql/queries/getAllGroups"
import { GET_ALL_TERMINALS } from "../graphql/queries/getAllTerminals"

export const useRemoveTerminalsFromGroup = ({
  onCompleted,
  onError,
  terminalId,
}: {
  onCompleted: any
  onError: any
  terminalId?: number | string
}) => {
  const [removeTerminalsFromGroup, { client, data, loading }] = useMutation(REMOVE_TERMINALS_FROM_GROUP, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [
      {
        query: GET_SUGGESTED_GROUPS_TERMINAL,
        variables: { terminalId: terminalId },
      },
      GET_ALL_TERMINALS,
      GET_MY_ORG_GROUPS,
      GET_ALL_GROUPS,
    ],
  })

  return { removeTerminalsFromGroup, data, loading, client }
}
